import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Clock, Landmark } from "lucide-react";
import { useApi, errMsg, euro } from "@/lib/api";

export const hoursLeft = (iso) => Math.max(0, Math.round((new Date(iso) - Date.now()) / 36e5));

export const PendingSummary = ({ orders }) => {
  const pending = orders.filter((o) => o.status === "pendiente_pago");
  if (!pending.length) return null;
  const total = pending.reduce((a, o) => a + o.total, 0);
  const soon = Math.min(...pending.map((o) => hoursLeft(o.expires_at)));
  return (
    <div className="border-2 border-amber-300 bg-amber-50 p-4 flex flex-wrap items-center gap-x-6 gap-y-1" data-testid="admin-pending-summary">
      <p className="flex items-center gap-2 font-bold text-amber-900"><Clock className="w-4 h-4" />
        <span data-testid="admin-pending-count">{pending.length}</span> {pending.length === 1 ? "pedido espera" : "pedidos esperan"} pago · {euro(total)}</p>
      <p className="text-sm text-amber-800">El primero caduca en <b data-testid="admin-pending-soonest">{soon} h</b></p>
    </div>
  );
};

export const BankSettings = () => {
  const call = useApi();
  const [bank, setBank] = useState(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { call("get", "/admin/bank").then((r) => setBank(r.data)).catch((e) => toast.error(errMsg(e, "No se pudieron cargar los datos bancarios"))); }, []);
  const save = async () => {
    try { const { data } = await call("put", "/admin/bank", bank); setBank(data); toast.success("Datos de transferencia guardados"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!bank) return null;
  return (
    <details className="border bg-white p-4" data-testid="admin-bank-settings">
      <summary className="cursor-pointer text-sm font-semibold flex items-center gap-2"><Landmark className="w-4 h-4" /> Datos para transferencia: <span className="font-mono font-normal">{bank.iban || "sin IBAN"}</span></summary>
      <div className="grid sm:grid-cols-[1fr_1fr_auto] gap-3 mt-4 items-end">
        <label className="block"><span className="text-xs font-semibold text-slate-600">IBAN</span>
          <input className="field mt-1 font-mono" value={bank.iban} onChange={(e) => setBank({ ...bank, iban: e.target.value })} data-testid="admin-bank-iban" /></label>
        <label className="block"><span className="text-xs font-semibold text-slate-600">Titular</span>
          <input className="field mt-1" value={bank.holder} onChange={(e) => setBank({ ...bank, holder: e.target.value })} data-testid="admin-bank-holder" /></label>
        <button onClick={save} className="btn-primary !h-11" data-testid="admin-bank-save">Guardar</button>
      </div>
    </details>
  );
};
